import React from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';

const { Header } = Layout;

const HeaderComponent = ({ logoData, locationName }) => {
  return (
    <div>
      <Header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          flexDirection: 'column',
          height: logoData ? '120px' : '32px',
        }}
      >
        {logoData && (
          <img
            src={`data:image/png;base64,${logoData}`}
            alt='ElimiWait Logo'
            id='elimiWaitLogo'
            style={{ height: '80px' }}
          />
        )}
      </Header>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    logoData: state.logoResponse.locationLogo,
    locationName: state.survey.data.LocationName,
  };
};

export default connect(mapStateToProps)(HeaderComponent);
